import React, { useState } from 'react'
import { Button, Icon ,Modal} from 'semantic-ui-react'
import { sendToBilling } from '../../../src/components/GB_App/api/getGBForm'

const SendToBilling = (props) => {

//   const [isLoading, setIsLoading] = React.useState(false)

const [isModalOpen, setIsModalOpen] = useState(false);
  const [isButtonVisible, setIsButtonVisible] = useState(true);

  const handleButtonClick = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };



const handleYesClick = async () => {
    // setIsLoading(true)
    let response = await sendToBilling(props.shipId)
    
      if (response) {
        setIsModalOpen(false);
        setIsButtonVisible(false);
      } else {
        console.error('API call failed');
      }
     
  }

  return (
    <div>
    {isButtonVisible && <Button
      id='sendtobillingbtn'
      size='mini'
      key='Download Button'
      className='sv todo-button primaryBtn'
    //   disabled={isLoading ? true : false}
      onClick={handleButtonClick}
    >
      SEND TO BILLING
    </Button>}
    <Modal size='tiny' open={isModalOpen} onClose={handleCloseModal}>
    <Modal.Header style={{ textAlign: 'center', color: 'red' }}>WARNING</Modal.Header>
    <Modal.Content>
      <p>{`Do you wish to send Job ${props.shipId} to billing ?`}</p>
    </Modal.Content>
    <Modal.Actions>
      <Button negative id="saveConfirmationNo" onClick={handleCloseModal}>
        No
      </Button>
      <Button positive id="saveConfirmationYes" onClick={handleYesClick}>
        Yes
      </Button>
    </Modal.Actions>
  </Modal>
  </div>
  )
}

export default SendToBilling